<template>
    <div>
        <div class="col-11 mx-auto text-center">
            <h2 class="text-primary font-weight-bold mb-2">
                Han confiado en nosotros
            </h2>
        </div>
        <div class="col-12">
            <carousel
                :responsive="{
                    0: {
                        items: 1,
                        nav: false,
                        mouseDrag: false,
                        stagePadding: 100,
                        loop: true,
                        margin: 15,
                        autoplay: true
                    },
                    600: {
                        items: 3,
                        nav: false,
                        mouseDrag: false,
                        stagePadding: 100,
                        loop: true,
                        margin: 15,
                        autoplay: true
                    },
                    800: {
                        items: 4,
                        nav: false,
                        mouseDrag: false,
                        stagePadding: 100,
                        loop: true,
                        margin: 15,
                        autoplay: true
                    }
                }"
            >
                <div
                    class="col-12 p-3 my-1"
                    v-for="(realstate, i) in realstates"
                    :key="i"
                >
                    <img class="img-logo" :src="realstate.logo" alt="" />
                </div>
            </carousel>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RealEstateAbout',
    props: ['realestatesjson'],
    data () {
        return {
            realstates: this.realestatesjson
        }
    }
}
</script>

<style scoped>
.img-logo {
    height: 8rem;
    filter: grayscale(1);
}
</style>
